export const NEXT_URL_QUERY_PARAM = 'next';

export const ROBOTS_TXT_PATH = '/robots.txt';
